// extracted by mini-css-extract-plugin
module.exports = {"contactOption":"ContactOption_contactOption__3dHqK","email":"ContactOption_email__2lhUK","team":"ContactOption_team__3Uy5C"};